import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import ContentCareersList from '../../../components/ContentCareersList'

const CareersListWidget = (props) => {
  const { data, location } = props

  let careers = data.allCareerCatfish
    ? data.allCareerCatfish.edges.map(({ node }) => node)
    : []

  let locations = data.careerLocations
    ? data.careerLocations.edges.map(({ node }) => node)
    : []

  let dealer = location ? locations.find((l) => l._id === location) : {}

  return careers.length > 0 ? (
    <ContentCareersList
      list={careers}
      locations={locations}
      location={dealer.slug}
    />
  ) : null
}

const CareersList = (props) => {
  const data = graphql`{
  allCareerCatfish {
    edges {
      node {
        _id
        title
        sell
        jobDescription
        candidateDescription
        otherInfo
        dealership {
          _id
          shortName
          slug
        }
      }
    }
  }
  careerLocations: allDealershipCatfish(sort: {shortName: ASC}) {
    edges {
      node {
        _id
        slug
        shortName
      }
    }
  }
}`

  return (
    <StaticQuery
      query={data}
      render={(data) => <CareersListWidget data={data} {...props} />}
    />
  )
}

export default CareersList
